import app from 'app';

function SubmitClaimBillUploadService(
  SubmitClaimBillUploadConstants,
  UploadFile,
  Api
) {
  function uploadtoZendesk(file) {
    return UploadFile.uploadFileToZendesk(file.file)
      .then((pathKey) => {
        file.pathKey = pathKey;
        file.isZendesk = true;
        file.status = SubmitClaimBillUploadConstants.status.UPLOADED;
        return file;
      })
      .catch(() => {
        file.status = SubmitClaimBillUploadConstants.status.FAILED;
        return file;
      });
  }
  function uploadToS3(file) {
    return UploadFile.uploadFile(file.file)
      .then((pathKey) => {
        file.pathKey = pathKey;
        file.isZendesk = false;
        file.status = SubmitClaimBillUploadConstants.status.UPLOADED;
        return file;
      })
      .catch(() => {
        file.status = SubmitClaimBillUploadConstants.status.FAILED;
        return file;
      });
  }
  function uploadFile(file) {
    file.status = SubmitClaimBillUploadConstants.status.UPLOADING;
    return Api.req({
      apiPrefix: '/api/v1',
      endPoint: '/membercoremiddleware/app_config/member.msoon.zendeskEnabled',
      method: 'GET',
    })
      .then((data) => {
        if (data.value && data.value.toLowerCase() === 'true') {
          return uploadtoZendesk(file);
        } else {
          return uploadToS3(file);
        }
      })
      .catch(() => {
        return uploadToS3(file);
      });
  }

  return {
    uploadFile,
    uploadtoZendesk,
    uploadToS3,
  };
}

app.service('SubmitClaimBillUploadService', SubmitClaimBillUploadService);
